// extracted by mini-css-extract-plugin
export var roundInProgressContainer = "RoundInProgress-module--roundInProgressContainer--2GDEi";
export var team = "RoundInProgress-module--team--x28y9";
export var movie = "RoundInProgress-module--movie--2bLUT";
export var remainingTime = "RoundInProgress-module--remainingTime--EiizG";
export var movieFoundButton = "RoundInProgress-module--movieFoundButton--3_ySi";
export var movieNotFoundButton = "RoundInProgress-module--movieNotFoundButton--1nul-";